import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=36156e9c&scoped=true&"
import script from "./FAQs.vue?vue&type=script&lang=js&"
export * from "./FAQs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36156e9c",
  null
  
)

export default component.exports